export function isIos() {
    const ua = window.navigator.userAgent;
    const isAppleMobile = /iPad|iPhone|iPod/.test(ua);
    const isIpadOS13Plus = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

    return isAppleMobile || isIpadOS13Plus;
}

export function isAndroid() {
    return /Android/.test(window.navigator.userAgent);
}

export function isStandalone() {
    return (
        window.matchMedia?.("(display-mode: standalone)").matches ||
        window.navigator.standalone === true
    );
}
